import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const dictionaryMembershipApi = generateNomenApi(`/dictionary/dictionary-membership`);

export const dictionaryMembershipOptions = generateNomenOptions('dictionary-membership', dictionaryMembershipApi);
